module.exports = __webpack_public_path__ + "img/carrusel-3.7ff6ff78.png";